import { render, staticRenderFns } from "./filereader.vue?vue&type=template&id=56506750&scoped=true&"
import script from "./filereader.vue?vue&type=script&lang=js&"
export * from "./filereader.vue?vue&type=script&lang=js&"
import style0 from "./filereader.vue?vue&type=style&index=0&id=56506750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56506750",
  null
  
)

export default component.exports